import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { AccountStatus, AccountType } from 'eve-account-client';
import EnrollmentSuccess from '../../../components/Enrollment/EnrollmentCompleted/EnrollmentSuccess';
import EnrollmentPending from '../../../components/Enrollment/EnrollmentCompleted/EnrollmentPending';
import { useEnrollment } from '../../../context/Enrollment/EnrollmentContext';
import ClientEnrollmentPending from '../../../components/Enrollment/EnrollmentCompleted/ClientEnrollmentPending';
import ChildEnrollmentPending from '../../../components/Enrollment/EnrollmentCompleted/ChildEnrollmentPending';
import { useGlobalData } from '../../../context/Global/GlobalContext';

const EnrollmentCompleted = (): JSX.Element => {
  // Note: completedEnrollment is of type Account
  const { completedEnrollment } = useEnrollment();
  const { isOnEnrollment, setIsOnEnrollment } = useGlobalData();

  const accountType = completedEnrollment?.type;

  useEffect(() => {
    if (isOnEnrollment) {
      setIsOnEnrollment(false);
    }
  });

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      pageTitle: 'E-Verify - Enrollment Completed',
    });
  }, []);

  const EnrollmentPendingByType = (): JSX.Element => {
    if (accountType === AccountType.CLIENT) {
      return <ClientEnrollmentPending />;
    }
    if (accountType === AccountType.CHILD) {
      return <ChildEnrollmentPending />;
    }
    return <EnrollmentPending />;
  };

  if (completedEnrollment?.status === AccountStatus.ACTIVE) {
    const accountTypeText = accountType === AccountType.CORPORATE ? 'corporate' : 'program';
    return <EnrollmentSuccess accountTypeText={accountTypeText} />;
  }

  return <EnrollmentPendingByType />;
};

export default EnrollmentCompleted;
